<template>
  <div class="family-parent-wrapper">
    <div class="role-wrapper">
      <span class="desc">
        当前身份:
        <span class="role">家长</span>
      </span>
      <div class="exclusive-code">我的专属码：{{ userInfo.exclusiveCode }}</div>
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      loading-text=""
      @load="onLoad"
    >
      <div class="content-wrapper" v-for="item in list" :key="item.userId">
        <p class="title">我的孩子</p>
        <div class="info">
          <img :src="item.headImageUrl" alt="" class="user-icon" />
          <div class="rg">
            <p class="nicname">昵称: {{ item.nickname }}</p>
            <p class="child-id">ID: {{ item.exclusiveCode }}</p>
          </div>
          <span class="bind-setup" @click="action_bind(item)">绑定设置</span>
        </div>
        <van-divider :style="{ borderColor: '#e3d3d3',height: '1px',margin:0}"/>
        <!-- <van-cell
          center
          title=""
          is-link
          
        /> -->
        <div class="cell-wrapper" @click="action_lookReadRecord(item)">
            <div>
                查看孩子阅读详情
            </div>
            <van-icon color="#c3c3c3" name="arrow">

            </van-icon>
        </div>
       <!--  <van-cell
          class="cell-wrapper"
          title="会员天数充值"
          is-link
          @click="action_chongzhi(item)"
        /> -->
      </div>
      <template #loading> </template>
      <template #finished> </template>
    </van-list>

    <van-button
      class="learn-flow-btn"
      plain
      type="info"
      @click="action_addChild()"
      >+ 添加孩子</van-button
    >
    <!--    <van-button class="learn-flow-btn" plain type="info" @click="action_addChild()">返回首页</van-button>-->

    <van-popup v-model="show">
      <vue-qr
        backgroundColor="#fff"
        :logoSrc="logo"
        :text="erCode"
        :size="180"
      ></vue-qr>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { getQrcode, getRecognize, getFamily } from "@/api/family";
import { wxConfigWXApi } from "@/lib/wxShare";
import { creatLansiId } from "@/lib/util";
import { mapState } from "vuex";
export default {
  name: "FamilyParent",
  data() {
    return {
      list: [],
      pageIndex: 0,
      pageSize: 20,
      show: false, //二维码展示
      erCode: "",
      logo: this.$store.state.user.userInfo.headImageUrl,
      loading: false,
      finished: false,
    };
  },

  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  activated() {
    // this.request_getFamily();
    console.log('====>>>>>>')
    this.list = new Array;
    this.loading = false;
    this.finished = false;
    this.pageIndex = 0;

  },

  methods: {

    //==============action=================
    //点击添加孩子
    action_addChild() {
      this.$router.replace({ path: "/bindChild" });
    },

    //点击查看孩子阅读
    action_lookReadRecord(item) {
      this.$router.replace({
        path: "/childReadDetail",
        query: { userId: item.userId },
      });
    },

    //   //点击会员充值
    //   action_chongzhi(item) {
    //     this.$router.push({path: '/payvip', query: {childInfo: JSON.stringify(item)}})
    //   },

    //点击绑定设置
    action_bind(item) {
      this.$router.push({
        name: "bindSetup",
        params: { childInfo: JSON.stringify(item) },
      });
    },

    //===============net==============
    //获取亲自列表
    onLoad() {
      // this.$loading.show()

      getFamily({
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      })
        .then((result) => {
          this.list = _.concat(this.list, result.data.records);
          this.pageIndex++;
          this.loading = false;
          if (result.data.records.length < this.pageSize) {
            this.finished = true;
          }
        })
        .catch(() => {});
    },

    //识别用户二维码
    request_getRecognize(result) {
      this.$loading.show();
      let params = {
        content: result,
      };
      getRecognize(params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          // {
          //   "headImageUrl": "xyz.jpg",
          //   "nickname": "昵称",
          //   "roleType": 1,
          //   "userId": 11
          // }
          const result = JSON.stringify(res.data);
          this.hanleScanResult(0, result);
        } else {
          this.$toast({
            message: res.msg,
            duration: 1000,
          });
        }
      });
    },

    //处理扫描结果
    hanleScanResult(tag, result) {
      //tag: 0 添加孩子  1 添加家长
      console.log(result);
      if (tag == 0) {
        this.$router.push({
          path: "/scanAddChild",
          query: { qrcodeResult: result },
        });
      } else {
        this.$router.push({
          path: "/scanAddParent",
          query: { qrcodeResult: result },
        });
      }
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../stylesheet/common.styl';

.family-parent-wrapper {
  box-sizing: border-box;
  height: 100vh;
  padding: 20px 15px;
  background-color: #fcfcfc;
}

.role-wrapper {
  padding: 0 15px;
  border-radius: 6px;
  display: flex;
  height: 48px;
  line-height: 48px;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  border-radius: 12px;
  background: linear-gradient(right, #98CEFF, #3994E7);
  box-shadow: 0px 20px 100px 0px #D6D6D6;

  .desc {
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
  }

  .exclusive-code {
    color: #DDEFFF;
    font-size: 12px;
  }

  .er-code-icon {
    width: 36px;
    height: 36px;
  }
}

.content-wrapper {
  margin-top: 20px;
  padding: 20px 15px;
  box-shadow: 0px 20px 100px 0px #D6D6D6;
  border-radius: 25px;
  background: #FFFFFF;

  .title {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
  }

  .info {
    display: flex;
    align-items: center;
    // border-bottom: 1px solid #F5F6F7;
    padding: 20px 0;
    border-radius: 6px;

    .user-icon {
      margin-right: 15px;
      width: 66px;
      height: 66px;
      border-radius: 33px;
      box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.19);
    }

    .rg {
      flex: 1;
      text-align: left;

      .nicname {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 4px;
      }

      .child-id {
        font-size: 12px;
        color: #999999;
      }
    }

    .bind-setup {
      padding: 4px 12px;
      color: $common-blue;
      border: 1px solid $common-blue;
      border-radius: 50px;
      font-weight :bold;
      font-size: 14px;
    }
  }
  .cell-wrapper{
      display: flex;
      margin-top: 20px
      align-items : center 
      font-weight :bold;
      justify-content : space-between
      color: #333333
  }
}

.learn-flow-btn {
  width: 100%;
  border-radius: 50px;
  margin-top: 16px;
  margin-bottom: 70px;
  background-color: #fff;
  color: $common-blue;
}
</style>



// WEBPACK FOOTER //
// app/pages/family/ChildList.vue